exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@media (max-width: 576px) {\n#post-list-page .w-fan-page .block-title {\n    margin-right: 20px;\n}\n#post-list-page .campaings {\n    margin-left: 0px;\n    margin-right: -15px !important;\n}\n}", ""]);

// exports
